module.exports = __webpack_public_path__ + "static/img/evidence2.048e411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence2.png
// module id = +1M1
// module chunks = 1 3